import { CloseOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { supportEmail } from 'utils/constants';

import './style.scss';

const TermsOfUseSupport = ({ closeModal }: { closeModal: () => void }) => {
  const { t } = useTranslation();

  return (
    <Modal
      // eslint-disable-next-line sonarjs/deprecation
      destroyOnClose={true}
      closeIcon={<CloseOutlined id="terms_close" />}
      className="termsmodal"
      maskClosable={false}
      onCancel={closeModal}
      open={true}
      title={t('auth.terms-of-use.declined')}
      centered
      footer={null}>
      <div className="termsmodal" data-testid="terms-declined-content">
        <p className="terms-contact">{t('auth.terms-of-use.contact')}</p>
        <div className="terms-contact">
          Email: <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
        </div>
      </div>
    </Modal>
  );
};

export default TermsOfUseSupport;
